/**
 * The one module of `src/schema/` that imports `zod` (1.0b deliverable 16). Every schema module
 * takes `z` from here, so this module's body runs before any module of the directory builds a
 * schema, whatever a consumer imports first.
 *
 * `jitless: true`, as P0-3's patch 1 did for contracts: Zod 4's object-schema constructor probes
 * whether `new Function` works, which the app's content security policy (`script-src 'self'`, no
 * `'unsafe-eval'`) reports as a violation on every page that loads a schema; the web bundle builds
 * these schemas (the sheet and card DTOs import them). With `jitless` Zod skips the probe and
 * parses with its interpreter, which gives the same results. The setting is Zod's global
 * configuration, so contracts and this package agree on it.
 *
 * String lengths count code points, as `packages/contracts/src/zod.ts` states for both packages.
 */
import { z } from 'zod';
z.config({ jitless: true });
export { z };
//# sourceMappingURL=zod.js.map